import React from "react";
import PropTypes from "prop-types";
import { PhoneNumberField } from "./PhoneNumber";
import classes from "./styles.module.scss";
import QuestionMark from "venuescanner-js/vanilla/widgets/enquiryForm/buttons/QuestionMark";

class AboutToCallYou extends React.Component {
  static propTypes = {
    number: PropTypes.string.isRequired,
    onChangeNumber: PropTypes.func.isRequired,
    onChangeSaveNumber: PropTypes.func.isRequired,
  };

  render() {
    const { number, onChangeNumber, onChangeSaveNumber } = this.props;

    return (
      <React.Fragment>
        <p>
          Enter your phone number below. We will call this number and then will
          connect your call
          <QuestionMark popupClassName={classes.FlexibleInput__popup}>
            We call you first to confirm your number. Once you answer, we
            connect you with the person you are trying to call. If the other
            person doesn’t answer then we will let them know you tried to call.
          </QuestionMark>
        </p>

        <div className={classes["PreCallPopup__number-wrapper"]}>
          <PhoneNumberField
            number={number}
            onChangeNumber={onChangeNumber}
            onChangeSaveNumber={onChangeSaveNumber}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default AboutToCallYou;
